import { DatePicker, Form, Input } from 'antd';
import CompanyCarSelector from '@/components/organisms/company/CompanyCarSelector';
import { FORMAT_DATE_SHORTEN_KR, FORMAT_DATE_EXCEPT_SECOND_KR } from '@/constants/constant';
import ContractWriteFormTemplate from '@/components/template/contract/ContractWriteFormTemplate';
import NumericInput from '@/components/organisms/common/NumericInput';

const ContractInformationForm = () => {
  const key = 'information';

  return (
    <ContractWriteFormTemplate title="계약 정보" name={key}>
      <Form.Item name={[key, 'no']} label="계약번호">
        <Input />
      </Form.Item>
      <Form.Item name={[key, 'companyCarId']} label="차량번호" rules={[{ required: true, message: '차량 번호를 입력해주세요' }]}>
        <CompanyCarSelector />
      </Form.Item>
      <Form.Item name={[key, 'carType']} label="차종">
        <Input />
      </Form.Item>
      <Form.Item name={[key, 'totalAmount']} label="계약금" rules={[{ required: true, message: '계약금 선택해주세요' }]}>
        <NumericInput decimal placeholder="0" suffix="원" />
      </Form.Item>
      <Form.Item name={[key, 'paidAmount']} label="지불액" rules={[{ required: true, message: '차량을 선택해주세요' }]}>
        <NumericInput decimal placeholder="0" suffix="원" />
      </Form.Item>
      <Form.Item name={[key, 'unpaidAmount']} label="미납액">
        <NumericInput decimal placeholder="0" suffix="원" />
      </Form.Item>
      <Form.Item name={[key, 'duration']} label="계약일" rules={[{ required: true, message: '계약기간을 선택해주세요' }]}>
        <DatePicker.RangePicker
          style={{ width: '100%' }}
          showTime
          showSecond={false}
          format={FORMAT_DATE_EXCEPT_SECOND_KR}
          placeholder={['시작일', '종료 예정일']}
        />
      </Form.Item>
      <Form.Item name={[key, 'dueAt']} label="반납일">
        <DatePicker style={{ width: '100%' }} format={FORMAT_DATE_SHORTEN_KR} placeholder="반납일" />
      </Form.Item>
    </ContractWriteFormTemplate>
  );
};

export default ContractInformationForm;
